import { getElement } from '../../utils/getElement';
/**
 * Searches and returns for a container element
 * @param incomingElement Id (string) or selector (string) or HTMLElement
 * @returns HTMLElement or null (if the element is not found)
 */
export var getContainerElement = function (incomingElement) {
    var element = getElement(incomingElement);
    if (!element) {
        return null;
    }
    return element;
};
/**
 * Сhecks the times (fallAsleepTime and forcedDepartureTime) depending on the type of device
 * @param deviceConfig Configuration with times
 * @returns Configuration with times is correct (true) or not (false)
 */
export var isUserActivityTimeCorrect = function (deviceConfig) {
    return (deviceConfig.fallAsleepTime &&
        deviceConfig.fallAsleepTime > 0 &&
        deviceConfig.forcedDepartureTime &&
        deviceConfig.forcedDepartureTime > 0);
};
/**
 * Сhecks value of percent
 * @param num Value
 * @returns Value is correct (true) or not (false)
 */
export var isPercent = function (num) { return num >= 0 && num <= 1; };
/**
 * Сhecks delay
 * @param delay Value
 * @returns Value is correct (true) or not (false)
 */
export var isDelayCorrect = function (delay) { return delay >= 0; };
/**
 * Checks number of items in hit
 * @param num Value
 * @returns Value is correct (true) or not (false)
 */
export var isNumberOfItemsInHitCorrect = function (num) { return num >= 1; };
/**
 * Checks selector validity
 * @param selector Selector
 * @returns Value is correct (true) or not (false)
 */
export var isSelectorValid = function (selector) {
    try {
        document.createDocumentFragment().querySelector(selector);
    }
    catch (_a) {
        return false;
    }
    return true;
};
/**
 * Checks string for an empty value
 * @param str String
 * @returns Value is not empty (true) or not (false)
 */
export var isNotEmptyString = function (str) { return str.trim() !== ''; };
